import { __rest } from "tslib";
import React, { useCallback, useMemo, useRef } from 'react';
import classnames from 'classnames';
import style from './main.module.scss';
import MenuBadge from '@web-common/components/MenuBadge';
import { BetaIcon } from '@web-common/components/UI/Icons/icons';
const SideBarTabItem = (_a) => {
    var { tab, unread, redPoint, className, active, showNewTag, showBetaTag, iconTagText = 'new', iconTagStyle = {} } = _a, props = __rest(_a, ["tab", "unread", "redPoint", "className", "active", "showNewTag", "showBetaTag", "iconTagText", "iconTagStyle"]);
    const { name, tag, icon: Icon } = tab;
    const dragRef = useRef(null);
    const unreadIconMemo = useMemo(() => {
        const showUnread = unread !== undefined && unread > 0;
        if (!showUnread) {
            return null;
        }
        if (redPoint) {
            return React.createElement("span", { className: style.redPoint });
        }
        const unreadText = process.env.BUILD_ISEDM ? (React.createElement("span", { className: style.text }, unread < 100 ? unread : '99+')) : (React.createElement("span", { className: style.text }, unread < 1000 ? unread : '···'));
        return React.createElement("span", { className: style.iconTag }, unreadText);
    }, [unread, redPoint]);
    const newTagMemo = useMemo(() => (React.createElement("span", { className: style.iconTag, style: iconTagStyle },
        React.createElement("span", { className: style.text }, iconTagText))), [iconTagText, iconTagStyle]);
    const betaTagMemo = useMemo(() => showBetaTag ? (React.createElement("div", { className: style.betaTag },
        React.createElement(BetaIcon, null))) : (React.createElement(React.Fragment, null)), [showBetaTag]);
    const iconMemo = useMemo(() => React.createElement(Icon, { enhance: active }), [active]);
    const handleClick = useCallback(() => {
        if (!active) {
            props.onClick && props.onClick(name);
        }
    }, [active, name, props.onClick]);
    const handleDoubleClick = useCallback(() => {
        if (active) {
            props.onDoubleClick && props.onDoubleClick(name, active);
        }
    }, [active, name]);
    if (process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) {
        return (React.createElement("div", { key: name, ref: dragRef, className: classnames([style.sideBarTab, process.env.BUILD_ISEDM ? style.sidebarTabEdm : ''], className), onMouseUp: handleClick, onDoubleClick: handleDoubleClick }, Icon && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: style.iconWrapper },
                React.createElement(MenuBadge, { path: name, position: "sup", comp: "asideRoot", wrapperStyle: { display: 'flex', flexDirection: 'column', alignItems: 'center' }, contentStyle: { transform: 'unset', right: 'unset', left: 12, top: -4 } }, iconMemo)),
            React.createElement("div", { className: style.sideBarTabLabel }, tag)))));
    }
    return (React.createElement("div", { key: name, ref: dragRef, className: classnames([style.sideBarTab], className), onMouseUp: handleClick, onDoubleClick: handleDoubleClick }, Icon && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: style.iconWrapper },
            iconMemo,
            showNewTag ? newTagMemo : unreadIconMemo,
            betaTagMemo),
        React.createElement("div", { className: style.sideBarTabLabel }, tag)))));
};
export default SideBarTabItem;
